import * as React from 'react';
import { DATA_HOOKS } from './constants';
import { st, classes } from './CounterBadge.st.css';
import {
  CounterBadgeDefaultProps,
  CounterBadgePriority,
  CounterBadgeProps,
} from './types';

class CounterBadge extends React.Component<CounterBadgeProps> {
  static displayName = 'CounterBadge';
  static defaultProps: CounterBadgeDefaultProps = {
    priority: CounterBadgePriority.primary,
    maximum: 99,
  };

  render() {
    const { priority, maximum, className, value } = this.props;

    const isMaximumNumber = value > maximum;
    const numberToPresent = isMaximumNumber ? `+${maximum}` : `${value}`;

    return (
      <div
        className={st(classes.root, classes[`priority-${priority}`], className)}
        data-priority={priority}
        data-hook={this.props['data-hook']}
      >
        <div
          className={st(classes.innerContainer, {
            maximumNumber: isMaximumNumber,
          })}
          data-hook={DATA_HOOKS.VALUE}
        >
          {numberToPresent}
        </div>
      </div>
    );
  }
}

export { CounterBadge };
